import { api } from '@/lib/api'
import type { ImportPreviewResponse, ImportResultResponse } from '@/types/import'

const COMMIT_TIMEOUT_MS = 30_000
const MULTIPART_HEADERS = { 'Content-Type': 'multipart/form-data' }

function buildFormData(file: File, accountId: number, brokerType: string): FormData {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('broker_type', brokerType)
  fd.append('account_id', String(accountId))
  return fd
}

export async function previewImport(
  file: File,
  accountId: number,
  brokerType: string,
): Promise<ImportPreviewResponse> {
  const { data } = await api.post<ImportPreviewResponse>(
    '/imports/preview',
    buildFormData(file, accountId, brokerType),
    { headers: MULTIPART_HEADERS },
  )
  return data
}

export async function commitImport(
  file: File,
  accountId: number,
  brokerType: string,
): Promise<ImportResultResponse> {
  const { data } = await api.post<ImportResultResponse>(
    '/imports/commit',
    buildFormData(file, accountId, brokerType),
    { headers: MULTIPART_HEADERS, timeout: COMMIT_TIMEOUT_MS },
  )
  return data
}
